import { SpinnerIcon } from '@phosphor-icons/react';

// Shared spinner glyph so the route-level fallback and the blocking LoadingOverlay stay visually
// in sync. Callers own the surrounding layout and the accessible label.
const LoadingSpinner = () => (
  <SpinnerIcon className="size-10 animate-spin text-[var(--m4-purple-700)]" aria-hidden />
);

export default LoadingSpinner;
